import React, { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const IdleTimeout = ({ timeoutDuration = 10 }) => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const handleTimeout = useCallback(() => {
    console.log('[IdleTimeout] timeout reached, redirecting to /app/session-timeout');
    localStorage.clear();
    navigate('/app/session-timeout');
  }, [navigate]);

  const resetTimeout = useCallback(() => {
    const timeoutDurationInMs = timeoutDuration * 60 * 1000;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    console.log('[IdleTimeout] activity detected, resetting timeout');
    timeoutRef.current = setTimeout(handleTimeout, timeoutDurationInMs);
  }, [handleTimeout, timeoutDuration]);

  useEffect(() => {
    const activityEvents = [
      'mousedown',
      'change',
      'keydown',
      'click',
      'input',
    ];

    console.log(`[IdleTimeout] initialising idle timeout for ${timeoutDuration} minute(s)`);
    resetTimeout();

    activityEvents.forEach((event) => window.addEventListener(event, resetTimeout));

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      activityEvents.forEach((event) => window.removeEventListener(event, resetTimeout));
      console.log('[IdleTimeout] cleaned up idle timeout listeners');
    };
  }, [resetTimeout, timeoutDuration]);

  return null;
};

export default IdleTimeout;